exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deselected-border[data-v-ad863e70]{border:2px solid transparent}.selected-border[data-v-ad863e70]{border:2px solid #877aaa}@media (min-width:992px){.limit-width[data-v-ad863e70]{max-width:160px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad863e70","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/forms/sponsorform/pricebox.vue
// module id = 0VRW
// module chunks = 1